<h2 mat-dialog-title>Ride List
  <button mat-icon-button class="close-button" (click)="onCloseDialog()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <div class="OrdersList">
    <div class="table-container">
      <div class="table-scroll">
        <table class="table">
          <thead>
            <tr class="table-head">
              <th class="fixed-column">S.No</th>
              <th class="fixed-column">Pick up</th>
              <th class="fixed-column">Drop</th>
              <th class="fixed-column">Driver Name</th>
              <th class="fixed-column">Vehicle Number</th>
              <th class="fixed-column">Fare</th>
              <th class="fixed-column">Payment Mode</th>
              <th class="fixed-column">Ride Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ride of dataview; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ (ride.pickUpAddress.pickUpAddressDetails) || '----' }}</td>
              <td>{{ (ride.destinationAddress.destinationAddressDetails) || '----' }}</td>
              <td>{{ (ride.driverName) || '----' }}</td>
              <td>{{ (ride.driverVehcile) || '----' }}</td>
              <td>{{ (ride.totalFare) || '----' }}</td>
              <td>{{ (ride.paymentMethod) || '----' }}</td>
              <td>{{ (ride.currentStatus) || '----' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="dataview.length === 0" class="no-records">
        No records found
      </div>
    </div>
  </div>
</mat-dialog-content>
